import React from 'react'

export interface IConditionProps {
  condition: boolean | undefined | null
  children: React.ReactNode
}

function Condition(props: IConditionProps) {
  const { condition, children } = props

  if (condition) {
    return (
      <React.Fragment>
        {children}
      </React.Fragment>
    )
  }

  return null
}

export default React.memo(Condition, (prevProps, nextProps) => !(prevProps.condition || nextProps.condition))
